import { FormikProvider, useFormik } from 'formik';
import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { Flex } from 'reflexbox';

import * as graphql from '@treams/treams-network';

import FilledInBy from './common/FilledInBy';
import Title from './common/Title';

export default function TitleModal(props: {
	fillInBy: graphql.EvaluationFillInBy;
	item: graphql.EvaluationTitleItem;
	onChange: (item: graphql.EvaluationTitleItem, fillInBy: graphql.EvaluationFillInBy) => void;
}) {
	const { t } = useTranslation();

	const formik = useFormik({
		initialValues: {
			text: props.item.text,
			fillInBy: props.fillInBy,
		},
		onSubmit: () => {},
	});

	useEffect(() => {
		if (!formik.values.text.find(({ text }) => text.length > 0)) {
			return;
		}

		props.onChange(
			{
				...props.item,
				text: formik.values.text,
			},
			formik.values.fillInBy,
		);
	}, [formik.values.text, formik.values.fillInBy]);

	return (
		<FormikProvider value={formik}>
			<Flex p={3} flexDirection="column">
				<Title label={t('common.settings.evaluationForms.properties.text.title')} name="text" />
				<FilledInBy />
			</Flex>
		</FormikProvider>
	);
}
